import { createContext } from 'react';

interface MessageBuilderContextValues {
    variant: 'email' | 'sms';
    messageId: number;
}

const MessageBuilderContext = createContext<MessageBuilderContextValues>({
    variant: 'email',
    messageId: 0,
});

export { MessageBuilderContext };
export type { MessageBuilderContextValues };
